import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
/* IMPORT HERE */

const apiaModal: ThemeUICSSObject = {
  genericModalWithBoxes: {
    '.genericModal__withBoxes__fieldWrapper': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      gap: spacing(3),
      fontWeight: 'bold',
      width: '100%',
      height: '100%',
    },
    '.genericModal__withBoxes__boxes': {
      width: '100%',
      height: '100%',
      alignItems: 'start',
      alignContent: 'start',
      maxHeight: responsive({ 0: '50vh', 3: '27vh' }),
      overflow: 'auto',
      display: 'grid',
      gap: spacing(3),
      pr: spacing(3),
      fontWeight: 'normal',
      gridTemplateColumns: responsive({
        0: 'repeat(1, 1fr)',
        3: 'repeat(2, 1fr)',
        5: 'repeat(3, 1fr)',
        6: 'repeat(4, 1fr)',
      }),
      '.labelBox, .infoBox': {
        backgroundColor: 'palette.background.paper',
        span: {
          display: 'block',
          textAlign: 'left',
          width: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        '.closeButton, .iconButton': (theme) => ({
          width: '32px',
          height: '32px',
          ...theme.palette.getStatesFromPath('buttons.outlineDanger', {
            states: {
              active: false,
              checked: false,
              default: false,
              disabled: false,
              focus: false,
              path: false,
              readonly: false,
              selected: false,
            },
          }),
          '&:hover': {
            ...theme.palette.getStatesFromPath('buttons.icon', {
              states: {
                active: false,
                checked: false,
                default: false,
                disabled: false,
                focus: false,
                hover: false,
                readonly: false,
                selected: false,
              },
            }),
          },
          '&:disabled': {
            opacity: 0.25,
          },
        }),
      },
    },
  },

  '.responsiveTableContext__wrapper': {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    height: '100%',

    '.selection__keyHandler': {
      height: '100%',
    },

    table: {
      tableLayout: 'auto',
    },

    '& > *:first-child': {
      height: '100%',
    },
  },
};

export default apiaModal;
